import { OperationTypeEnum } from "@gtpl/shared-models/common-models";
import { PeelingRateBasedEnum } from "../enums";

export class ScopeGradeReq{
    scope : string;
    grade : number;
    priceBasedOn : PeelingRateBasedEnum
    isRRP ?: boolean
    operation?: OperationTypeEnum

    constructor(scope : string,grade : number,priceBasedOn : PeelingRateBasedEnum,isRRP ?: boolean,operation?: OperationTypeEnum){
        this.scope = scope
        this.grade = grade
        this.priceBasedOn = priceBasedOn
        this.isRRP = isRRP
        this.operation = operation
    }
}